import { clsx } from 'clsx';

const Divider = ({
  className,
}: {
  className?: HTMLDivElement['className'];
}) => (
  <div
    role="separator"
    className={clsx(['border-b border-b-gray-300', className])}
  />
);

export { Divider };
